import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch } from "react-redux";

import i18n from "../i18n";
import { sendError } from "../errors";
import taskApi from "../api/task";
import products from "../api/products";

import Button from "./Button.jsx";
import ErrorState from "./ErrorState.jsx";
import Page from "./Page.jsx";
import { setLoading } from "../store";

export default function ProductPage(props) {
  const [data, setData] = useState({});
  const [error, setError] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [resultSaved, setResultSaved] = useState(false);
  const dispatch = useDispatch();

  useEffect(async () => {
    if (!props.doneOnClose || !data.product) {
      return;
    }
    await taskApi.selectResult(props.taskId, data.product.id);
    setResultSaved(true);
  }, [data]);

  async function selectProduct(event) {
    event.preventDefault();
    if (!resultSaved) {
      await taskApi.selectResult(props.taskId, data.product.id);
    }
    props.onNext();
  }

  useEffect(async () => {
    try {
      setError(null);
      dispatch(setLoading(true));
      setData(await products.fetch(props.productId));
    } catch (err) {
      sendError(err);
      // TODO: some handing is needed here
      setError(err);
    }
    dispatch(setLoading(false));
    setLoaded(true);
  }, []);

  if (!loaded) {
    return null;
  }

  return (
    <div>
      {error && <ErrorState />}
      {!error && !data.product && (
        <div>
          <p>We don’t have any product for you.</p>
          <Button outlined onClick={props.onRestart} class="mr-16">
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      )}
      {!error && data.product && (
        <Page
          product={data.product}
          pageId={data.product.page}
          productId={data.product.id}
          onClose={props.onClose}
          onNext={selectProduct}
          onRestart={props.onRestart}
        />
      )}
    </div>
  );
}
